/**
 * @file index.tsx
 * @author liuchen(loocliu@tencent.com)
 */
import React from 'react';

import ChatInput from './chatInput';
import styles from './style/index.module.less';

interface IFooterProps {
  disabled?: boolean;
  onSubmit: (value: string, botIds: string[], notHideKeyboard?: boolean) => void;
  style?: React.CSSProperties;
}

const Footer = ((props: IFooterProps) => {
  const {
    disabled = false,
    onSubmit,
    style,
  } = props;

  return (
    <div className={styles.root} style={{ ...style }}>
      <ChatInput
        disabled={disabled}
        onSubmit={onSubmit}
      />
    </div>
  );
});

export default (Footer);
